import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
/**
 * Used by oidc WebStorageStateStore, and must match interface used by oidc.
 * See https://github.com/IdentityModel/oidc-client-js/blob/fd838832aaacdaf1b8bd213c8e3787150f33af4d/src/WebStorageStateStore.js
 */
export class SessionCookieStore {
  constructor(private cookieService: CookieService) {}

  setItem(key: string, value: string): void {
    this.cookieService.set(
      key,
      value,
      undefined,
      '/',
      undefined,
      location.protocol.indexOf('https') === 0,
      'Lax'
    );
  }

  getItem(key: string): string {
    return this.cookieService.get(key);
  }

  removeItem(key: string): void {
    this.cookieService.delete(key);
  }

  key(index: number) {
    return Object.keys(this.cookieService.getAll())[index];
  }

  get length(): number {
    return Object.keys(this.cookieService.getAll()).length;
  }
}
